import { controlSponsorReportApi } from "./axios";
import {
  ServiceResponseI,
  SponsorReportSummaryI,
  SponsorReportDetailI,
  GetSponsorReportParamsI,
} from "@interfaces";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { AxiosError } from "axios";

export const getControlSponsorReportSummary = async (
  params: GetSponsorReportParamsI,
): Promise<ServiceResponseI<SponsorReportSummaryI[]>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const query = new URLSearchParams();
    if (params.dateFrom) query.append("dateFrom", params.dateFrom);
    if (params.dateTo) query.append("dateTo", params.dateTo);

    const { data } = await controlSponsorReportApi.get<
      ServiceResponseI<SponsorReportSummaryI[]>
    >("", { params: query, headers: { Authorization: validateToken } });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const getControlSponsorReportDetail = async (
  id: string,
  params: GetSponsorReportParamsI,
): Promise<ServiceResponseI<SponsorReportDetailI>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const query = new URLSearchParams();
    if (params.dateFrom) query.append("dateFrom", params.dateFrom);
    if (params.dateTo) query.append("dateTo", params.dateTo);

    const { data } = await controlSponsorReportApi.get<
      ServiceResponseI<SponsorReportDetailI>
    >(`/${id}`, { params: query, headers: { Authorization: validateToken } });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};
